
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma

/**
 * Prisma Client JS version: 3.14.0
 * Query Engine version: 2b0c12756921c891fec4f68d9444e18c7d5d4a6a
 */
Prisma.prismaVersion = {
  client: "3.14.0",
  engine: "2b0c12756921c891fec4f68d9444e18c7d5d4a6a"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = () => (val) => val

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = 'DbNull'
Prisma.JsonNull = 'JsonNull'
Prisma.AnyNull = 'AnyNull'

/**
 * Enums
 */
// Based on
// https://github.com/microsoft/TypeScript/issues/3192#issuecomment-261720275
function makeEnum(x) { return x; }

exports.Prisma.IdentityScalarFieldEnum = makeEnum({
  id: 'id',
  magic_key: 'magic_key',
  user_id: 'user_id',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.UserScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  primary_email: 'primary_email',
  emails: 'emails',
  created_at: 'created_at',
  updated_at: 'updated_at',
  role: 'role'
});

exports.Prisma.WorkspaceScalarFieldEnum = makeEnum({
  id: 'id',
  store_id: 'store_id',
  name: 'name',
  current_phase_id: 'current_phase_id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  group_id: 'group_id',
  status: 'status',
  parent_workspace_id: 'parent_workspace_id',
  partnerType: 'partnerType',
  workspaceType: 'workspaceType'
});

exports.Prisma.DealInfoScalarFieldEnum = makeEnum({
  id: 'id',
  workspace_id: 'workspace_id',
  offer_amount: 'offer_amount',
  diligence_date: 'diligence_date',
  closing_amount: 'closing_amount',
  closing_date: 'closing_date',
  transition_amount: 'transition_amount',
  transition_date: 'transition_date',
  transfer_amount: 'transfer_amount',
  accept_date: 'accept_date',
  performance_bonus: 'performance_bonus',
  weekly_price_target: 'weekly_price_target',
  marketing_budget: 'marketing_budget',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.ProductDataMigrationScalarFieldEnum = makeEnum({
  id: 'id',
  workspace_id: 'workspace_id',
  airtable_id: 'airtable_id',
  job_status: 'job_status',
  product_data_status: 'product_data_status',
  netsuite_id: 'netsuite_id'
});

exports.Prisma.PhaseScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  slug: 'slug',
  created_at: 'created_at',
  updated_at: 'updated_at',
  order: 'order'
});

exports.Prisma.FormTemplateScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  phase_id: 'phase_id',
  schema: 'schema',
  task_trigger: 'task_trigger',
  target_role: 'target_role',
  order: 'order',
  status: 'status',
  created_at: 'created_at',
  updated_at: 'updated_at',
  slug: 'slug'
});

exports.Prisma.TaskScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  workspace_id: 'workspace_id',
  task_type: 'task_type',
  phase_id: 'phase_id',
  status: 'status',
  target_role: 'target_role',
  data: 'data',
  order: 'order',
  created_at: 'created_at',
  updated_at: 'updated_at',
  completed_at: 'completed_at'
});

exports.Prisma.GroupScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.InviteScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  email: 'email',
  group_id: 'group_id',
  status: 'status',
  expires_at: 'expires_at',
  partner: 'partner',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.ActivityLogScalarFieldEnum = makeEnum({
  id: 'id',
  description: 'description',
  user_id: 'user_id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  workspace_id: 'workspace_id',
  form_template_id: 'form_template_id',
  task_id: 'task_id',
  group_id: 'group_id',
  invite_id: 'invite_id',
  s3FileId: 's3FileId',
  atm_account_id: 'atm_account_id'
});

exports.Prisma.S3FileScalarFieldEnum = makeEnum({
  id: 'id',
  key: 'key',
  bucket: 'bucket',
  region: 'region',
  type: 'type',
  acl: 'acl',
  size: 'size',
  task_id: 'task_id',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.AtmAccountScalarFieldEnum = makeEnum({
  id: 'id',
  title: 'title',
  username: 'username',
  url: 'url',
  comments: 'comments',
  active: 'active',
  requires_2fa: 'requires_2fa',
  login_update: 'login_update',
  access_audit: 'access_audit',
  status: 'status',
  workspace_id: 'workspace_id',
  account_type_id: 'account_type_id',
  one_pass_item_id: 'one_pass_item_id',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.OnePassItemScalarFieldEnum = makeEnum({
  id: 'id',
  one_pass_item_id: 'one_pass_item_id',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.AtmAccountTypeScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  url: 'url',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.PopulatedDocumentScalarFieldEnum = makeEnum({
  id: 'id',
  url: 'url',
  name: 'name',
  template_name: 'template_name',
  template_url: 'template_url',
  created_at: 'created_at',
  updated_at: 'updated_at',
  workspace_id: 'workspace_id'
});

exports.Prisma.WorkspaceMetricsScalarFieldEnum = makeEnum({
  id: 'id',
  workspace_id: 'workspace_id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  seconds_in_diligence: 'seconds_in_diligence',
  seconds_in_closing: 'seconds_in_closing',
  seconds_in_transition: 'seconds_in_transition',
  seconds_merchant_waiting_on_os: 'seconds_merchant_waiting_on_os',
  seconds_os_waiting_on_merchant: 'seconds_os_waiting_on_merchant',
  diligence_completed_at: 'diligence_completed_at',
  closing_completed_at: 'closing_completed_at',
  transition_completed_at: 'transition_completed_at'
});

exports.Prisma.AddressScalarFieldEnum = makeEnum({
  id: 'id',
  address_line_1: 'address_line_1',
  address_line_2: 'address_line_2',
  city: 'city',
  state_or_province: 'state_or_province',
  postal_code: 'postal_code',
  country: 'country',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.BankInfoScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  address_id: 'address_id',
  account_holder_name: 'account_holder_name',
  swift_code: 'swift_code',
  cnaps_code: 'cnaps_code',
  account_number: 'account_number',
  beneficiary_name: 'beneficiary_name',
  payment_notification_email: 'payment_notification_email',
  beneficiary_phone_number: 'beneficiary_phone_number',
  beneficiary_fax: 'beneficiary_fax',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.VendorScalarFieldEnum = makeEnum({
  id: 'id',
  workspace_id: 'workspace_id',
  name: 'name',
  type: 'type',
  primary_contact_email: 'primary_contact_email',
  bill_dot_com_account_number: 'bill_dot_com_account_number',
  address_id: 'address_id',
  bill_currency: 'bill_currency',
  bank_info_id: 'bank_info_id',
  contact_first_name: 'contact_first_name',
  contact_last_name: 'contact_last_name',
  vendor_description: 'vendor_description',
  tax_id: 'tax_id',
  is_1099_vendor: 'is_1099_vendor',
  payment_term_id: 'payment_term_id',
  created_at: 'created_at',
  updated_at: 'updated_at'
});

exports.Prisma.SortOrder = makeEnum({
  asc: 'asc',
  desc: 'desc'
});

exports.Prisma.NullableJsonNullValueInput = makeEnum({
  DbNull: 'DbNull',
  JsonNull: 'JsonNull'
});

exports.Prisma.JsonNullValueInput = makeEnum({
  JsonNull: 'JsonNull'
});

exports.Prisma.QueryMode = makeEnum({
  default: 'default',
  insensitive: 'insensitive'
});

exports.Prisma.JsonNullValueFilter = makeEnum({
  DbNull: 'DbNull',
  JsonNull: 'JsonNull',
  AnyNull: 'AnyNull'
});
exports.UserRole = makeEnum({
  INTERNAL: 'INTERNAL',
  MERCHANT: 'MERCHANT',
  PARTNER: 'PARTNER'
});

exports.WorkspaceStatus = makeEnum({
  CREATED: 'CREATED',
  ARCHIVED: 'ARCHIVED'
});

exports.WorkspaceType = makeEnum({
  MERCHANT: 'MERCHANT',
  PARTNER: 'PARTNER'
});

exports.PartnerType = makeEnum({
  MARKETING: 'MARKETING',
  CUSTOMER_SERVICE: 'CUSTOMER_SERVICE',
  SUPPLY_CHAIN: 'SUPPLY_CHAIN',
  ACCOUNTING: 'ACCOUNTING',
  OTHER: 'OTHER'
});

exports.ProductDataStatus = makeEnum({
  NONE: 'NONE',
  IMPORTING: 'IMPORTING',
  EDITING: 'EDITING',
  EXPORTING: 'EXPORTING',
  COMPLETE: 'COMPLETE'
});

exports.FormTemplateTaskTrigger = makeEnum({
  PHASE_START: 'PHASE_START',
  MANUAL: 'MANUAL'
});

exports.FormTemplateStatus = makeEnum({
  CREATED: 'CREATED',
  ARCHIVED: 'ARCHIVED'
});

exports.TaskType = makeEnum({
  FORM: 'FORM',
  ATM: 'ATM',
  CONNECTOR: 'CONNECTOR',
  PRODUCT: 'PRODUCT',
  ARCHIVE_FULFILLED_ORDER: 'ARCHIVE_FULFILLED_ORDER',
  PARTNER_BILLING_REGISTRATION: 'PARTNER_BILLING_REGISTRATION',
  INVENTORY_TRANSFER: 'INVENTORY_TRANSFER'
});

exports.TaskStatus = makeEnum({
  CREATED: 'CREATED',
  COMPLETE: 'COMPLETE',
  IN_PROGRESS: 'IN_PROGRESS',
  INCOMPLETE: 'INCOMPLETE',
  ARCHIVED: 'ARCHIVED'
});

exports.InviteStatus = makeEnum({
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  EXPIRED: 'EXPIRED',
  CANCELLED: 'CANCELLED'
});

exports.AtmAccountStatus = makeEnum({
  UNTESTED: 'UNTESTED',
  VALID: 'VALID',
  INVALID: 'INVALID'
});

exports.VendorType = makeEnum({
  BUSINESS: 'BUSINESS',
  INDIVIDUAL: 'INDIVIDUAL'
});

exports.Prisma.ModelName = makeEnum({
  Identity: 'Identity',
  User: 'User',
  Workspace: 'Workspace',
  DealInfo: 'DealInfo',
  ProductDataMigration: 'ProductDataMigration',
  Phase: 'Phase',
  FormTemplate: 'FormTemplate',
  Task: 'Task',
  Group: 'Group',
  Invite: 'Invite',
  ActivityLog: 'ActivityLog',
  S3File: 'S3File',
  AtmAccount: 'AtmAccount',
  OnePassItem: 'OnePassItem',
  AtmAccountType: 'AtmAccountType',
  PopulatedDocument: 'PopulatedDocument',
  WorkspaceMetrics: 'WorkspaceMetrics',
  Address: 'Address',
  BankInfo: 'BankInfo',
  Vendor: 'Vendor'
});

/**
 * Create the Client
 */
class PrismaClient {
  constructor() {
    throw new Error(
      `PrismaClient is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
    )
  }
}
exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
